// extracted by mini-css-extract-plugin
module.exports = {"collapsible":"Collapsible_collapsible__Hfn9B"};